import { render, staticRenderFns } from "./SaveAsDraftButton.vue?vue&type=template&id=778d473d&scoped=true&"
import script from "./SaveAsDraftButton.vue?vue&type=script&lang=js&"
export * from "./SaveAsDraftButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778d473d",
  null
  
)

export default component.exports